import styled from 'styled-components/macro';
import { colorBlackTransparent50 } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
export const QuoteContainerStyled = styled.div `
  padding: ${({ isRightToLeft }) => isRightToLeft
    ? `${INDENT.sm} ${INDENT.xxxl} ${INDENT.sm} ${INDENT.sm}`
    : `${INDENT.sm} ${INDENT.sm} ${INDENT.sm} ${INDENT.xxxl}`};
  background: ${colorBlackTransparent50};
  position: relative;
  white-space: break-spaces;
`;
export const AuthorStyled = styled.div `
  margin-top: ${INDENT.xs};
`;
export const IconStyled = styled.div `
  position: absolute;
  top: ${INDENT.xxs};
  ${({ isRightToLeft }) => (isRightToLeft ? `right: ${INDENT.xxs}` : `left: ${INDENT.xxs}`)};
`;
